module.exports = __webpack_public_path__ + "img/plateTitleBg.3331575a.png";